/* Matapayals — AJAX add-to-cart + wireframe cart drawer. */
(function () {
  'use strict';

  var root, drawer, itemsEl, subtotalEl, countEl, shipEl, emptyEl, toastEl, toastMsg, threshold, toastT;

  function money(cents) {
    return '₹ ' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function openDrawer() { if (root) { root.classList.add('show'); document.body.style.overflow = 'hidden'; if (drawer) drawer.setAttribute('aria-hidden', 'false'); } }
  function closeDrawer() { if (root) { root.classList.remove('show'); document.body.style.overflow = ''; if (drawer) drawer.setAttribute('aria-hidden', 'true'); } }

  function toast(msg) {
    if (!toastEl) return;
    toastMsg.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }

  function render(cart) {
    if (!itemsEl) return;
    countEl.textContent = cart.item_count;
    subtotalEl.textContent = money(cart.total_price);

    if (!cart.items.length) {
      itemsEl.innerHTML = '';
      itemsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (shipEl) shipEl.hidden = true;
      return;
    }
    itemsEl.hidden = false;
    if (emptyEl) emptyEl.hidden = true;

    // free-ship / gift progress
    if (shipEl && threshold > 0) {
      shipEl.hidden = false;
      if (cart.total_price >= threshold) {
        shipEl.innerHTML = "🎁 You've unlocked your <b>free silver care kit</b>!<div class=\"t\"><i style=\"width:100%\"></i></div>";
      } else {
        var left = threshold - cart.total_price;
        var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
        shipEl.innerHTML = "You're <b>" + money(left) + "</b> away from a <b>free silver care kit</b> 🎁<div class=\"t\"><i style=\"width:" + pct + "%\"></i></div>";
      }
    } else if (shipEl) {
      shipEl.hidden = true;
    }

    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2') : '';
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).filter(function (v) { return v && v !== 'Default Title'; }).join(' · ');
      return '<div class="dr-item" data-line="' + (i + 1) + '">' +
        '<a href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') + '</a>' +
        '<div>' +
          '<h5><a href="' + it.url + '" style="color:inherit;text-decoration:none">' + it.product_title + '</a></h5>' +
          (opts ? '<small>' + opts + '</small>' : '<small></small>') +
          '<div class="row">' +
            '<div class="qty"><button data-mp-qty="-1" aria-label="Decrease">−</button><b>' + it.quantity + '</b><button data-mp-qty="1" aria-label="Increase">+</button>' +
            '</div><button class="dr-rm" data-mp-remove aria-label="Remove">Remove</button>' +
            '<span class="price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function refresh(open) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (open) openDrawer(); })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); }).catch(function () {});
  }

  function addToCart(form) {
    var data = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) { toast(res.body && res.body.description ? res.body.description : 'Could not add to cart'); return; }
        toast((res.body.product_title || 'Item') + ' added to cart');
        refresh(true);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } window.location.href = '/cart'; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    root = document.querySelector('.mp-cart');
    if (!root) return;
    drawer = document.getElementById('mpDrawer');
    itemsEl = root.querySelector('[data-mp-items]');
    subtotalEl = root.querySelector('[data-mp-subtotal]');
    countEl = root.querySelector('[data-mp-count]');
    shipEl = root.querySelector('[data-mp-ship]');
    emptyEl = root.querySelector('[data-mp-empty]');
    toastEl = document.getElementById('mpToast');
    toastMsg = root.querySelector('[data-mp-toast-msg]');
    threshold = parseInt(root.getAttribute('data-free-ship-threshold') || '0', 10);

    // public hook for other scripts (e.g. PDP bundle add)
    window.MPCart = { open: function () { refresh(true); }, refresh: refresh };
    document.addEventListener('mp:cart:open', function () { refresh(true); });

    refresh(false);

    // intercept add-to-cart forms (PLP cards, PDP) — skip the theme's own product form
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.classList.contains('js-product-form')) return; // let theme handle its own
      e.preventDefault();
      addToCart(form);
    });

    // open drawer from any cart link
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a) {
        var href = a.getAttribute('href') || '';
        if (/\/cart$/.test(href.split('?')[0]) && !a.hasAttribute('data-mp-cart-close')) {
          e.preventDefault(); refresh(true); return;
        }
      }
      if (e.target.closest('[data-mp-cart-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-mp-open-cart]')) { e.preventDefault(); refresh(true); return; }

      var q = e.target.closest('[data-mp-qty]');
      if (q) {
        var itemEl = q.closest('.dr-item');
        var line = parseInt(itemEl.getAttribute('data-line'), 10);
        var cur = parseInt(itemEl.querySelector('.qty b').textContent, 10);
        changeLine(line, Math.max(0, cur + parseInt(q.getAttribute('data-mp-qty'), 10)));
        return;
      }
      var rm = e.target.closest('[data-mp-remove]');
      if (rm) {
        var el = rm.closest('.dr-item');
        changeLine(parseInt(el.getAttribute('data-line'), 10), 0);
        return;
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  });
})();
